import React from 'react';
import '../styles/AcaciaPowder.css';

const productSpecs = [
  { label: 'Product Name', value: 'Cutch Block' },
  { label: 'Product Composition', value: 'Natural concentrated catechu extract obtained from Acacia Catechu wood. Appearance: Dark brown to black glossy solid blocks.' },
  { label: 'Dangerous Ingredients', value: 'None' },
  { label: 'Available in', value: 'Solid blocks packed in export-grade packaging or customized bulk packaging' },
];

const industrialUses = [ 
  'Widely used in vegetable leather tanning industry',
  'Used in natural dyeing and coloring applications',
  'Improves leather firmness, fullness, and durability',
  'Used in adhesive and resin manufacturing',
  'Used in incense sticks and traditional extract industries',
  'Used as a natural flavouring and confectionery ingredient in food-grade applications',
  'Preferred ingredient in confectionery and mouth-freshener applications',
];

const medicalUses = [
  'Rich in natural tannins and polyphenols',
  'Traditionally used in Ayurvedic and traditional Indian herbal preparations',
  'Used in chewable herbal preparations as a natural astringent base',
  'Used in flavoured mouth fresheners and natural oral care products',
  'Contains strong natural astringent properties',
  'Used in traditional plant-based formulations',
  'Natural extract with antioxidant characteristics',
];

function AcaciaPowder() {
  return (
    <div className="acacia-page">

      {/* Banner Image */}
      <div className="acacia-banner">
        <img src="/all.png" alt="Acacia Catechu Banner" className="acacia-banner-img" />
      </div>

      {/* Main Content */}
      <div className="acacia-container">
        <div className="acacia-left">

          <h2 className="acacia-title">
            Cutch Blocks
          </h2>

          <p className="acacia-desc">
            <strong>Cutch Blocks</strong> is a natural concentrated extract obtained from the
            heartwood of the Acacia Catechu tree. It is traditionally processed by boiling and
            concentrating catechu extract into solid dark brown or black glossy blocks. Cutch is
            widely valued for its high tannin content, natural binding properties, and use in
            leather tanning, dyeing, adhesives, incense, traditional Indian herbal preparations,
            and industrial applications.
          </p>

          <p className="acacia-desc">
            These blocks are known for their rich color, strong astringent characteristics, and
            natural plant-based composition. Due to their excellent tannin concentration and
            eco-friendly origin, cutch blocks are commonly used in vegetable tanning industries,
            flavoured mouth fresheners, and natural flavouring and confectionery ingredient
            formulations worldwide.
          </p>

          <p className="acacia-desc">
            Cutch blocks provide excellent tanning performance, deep natural coloration, improved
            leather firmness, and natural preservative properties. Their suitability as a natural
            flavouring and confectionery ingredient, combined with their role in chewable herbal
            preparations and confectionery and mouth-freshener applications, makes them a preferred
            natural extract across multiple sectors.
          </p>

          <h3 className="acacia-subtitle">Product Identification &amp; Specifications:</h3>
          <table className="acacia-table">
            <tbody>
              {productSpecs.map((s, i) => (
                <tr key={i}>
                  <td className="acacia-spec-label">{s.label}</td>
                  <td className="acacia-spec-value">{s.value}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3 className="acacia-subtitle">Industrial Use:</h3>
          <ul className="acacia-uses">
            {industrialUses.map((u, i) => (
              <li key={i}>{u}</li>
            ))}
          </ul>

          <h3 className="acacia-subtitle">Medical Use:</h3>
          <ul className="acacia-uses">
            {medicalUses.map((u, i) => (
              <li key={i}>{u}</li>
            ))}
          </ul>

        </div>
      </div>
    </div>
  );
}

export default AcaciaPowder;